export const SUBHEADER_UPDATE = 'COMMON/SUBHEADER/UPDATE';
export const SUBHEADER_APPEND = 'COMMON/SUBHEADER/APPEND';
export const SUBHEADER_RESET = 'COMMON/SUBHEADER/RESET';
export const SUBHEADER_POP = 'COMMON/SUBHEADER/POP';
